import { useState, useEffect } from "react";
import Header from "../../../Global/Header/Header";
import Footer from "../../../Global/Footer/Footer";
import { CalendarIcon } from "@radix-ui/react-icons";
import { Input } from "../../../components/ui/input";
import { set } from "date-fns";
import { createUrl, post, get } from "../../../network/AxiosInterceptor";

const AddSvg = (props) => {
  const [svgLabel, setSvgLabel] = useState("");
  const [svgCode, setSvgCode] = useState("");
  const [svgId, setSvgId] = useState("");
  const [svgList, setSvgList] = useState([]);

  useEffect(() => {
    get(createUrl("/api/svg/getSvgs"))
      .then((response) => {
        setSvgList(response.data);
      })
      .catch((error) => {
        console.log("error fetching svgs");
      });
  }, [svgList]);

  const onSvgLabelChange = (e) => {
    setSvgLabel(e.target.value);
  };

  const onSvgCodeChange = (e) => {
    setSvgCode(e.target.value);
  };

  const submitHandler = () => {
    post(createUrl("/api/svg/createSvg"), {
      id: svgId,
      svgLabel: svgLabel,
      svgCode: svgCode,
    })
      .then((response) => {
        console.log(response, " response");
        if (response.status.startsWith("2")) {
          setSvgList((prev) => [...prev, response.data]);
        }
      })
      .catch((error) => {
        console.log("error fetching svgs");
      });
  };

  return (
    <div className="w-[100vw] min-h-[100vh]">
      <Header />
      <div className="w-[80vw]  flex flex-col mb-[10vw] lg:mb-[5vw] ml-[10vw] space-y-4">
        <p className="text-[6vw] lg:text-[4vw] self-center">Add Svg</p>
        <Input
          id={`svg-label`}
          value={svgLabel}
          placeholder="SVG Label"
          onChange={(e) => {
            onSvgLabelChange(e);
          }}
        />
        <Input
          id={`svg-code`}
          value={svgCode}
          placeholder="SVG Code"
          onChange={(e) => {
            onSvgCodeChange(e);
          }}
        />
        <div className="flex flex-row gap-x-[6vw] lg:gap-x-[4vw] ml-auto mb-[8vw] lg:mb-[4vw]">
          <button
            className="w-[23vw] h-[10vw] lg:w-[10vw] lg:h-[3vw] rounded-[5px] bg-green-400 lg:text-[1.4vw]"
            onClick={submitHandler}
          >
            {svgId ? "Save" : "Create"}
          </button>
        </div>
        {svgList.length > 0 && (
          <>
            <p className="text-[6vw] lg:text-[4vw] self-center">
              List of Svg's
            </p>
            <div className="flex flex-col w-full mt-[2vw] mb-[4vw] border-[1.5px] border-input rounded-xl self-center overflow-hidden">
              {svgList.map((svg, index) => (
                <div className="flex flex-row justify-between px-[4vw] lg:px-[2vw] items-center border-b-[1.5px] border-input last:border-none py-3">
                  <p className="text-[3.5vw] lg:text-[1.3vw] font-[300]">
                    {svg.svgLabel}
                  </p>
                  {
                    // <CalendarIcon className="w-[6vw] h-[6vw] lg:w-[3vw] lg:h-[3vw]" />
                    <SvgPassing
                      content={svg.svgCode}
                      className="w-[6vw] h-[6vw] lg:w-[3vw] lg:h-[3vw]"
                      svgLabel={svg.svgLabel}
                    />
                  }
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AddSvg;

const SvgPassing = (props) => {
  const content = props.content;
  const className = props.className;
  if (content.substr(0,20).includes("class")) {
    var parts = content.split(/(class="[^"]*")/);
    var newPart = parts[1].split(`"`);
    newPart[1] = `${newPart[1]} ${className}`;
    parts[1] = newPart.join(`"`);
    parts = parts.join("");
  }else{
    var parts = content.split("svg");
    parts[1] = `class="${className}" ${parts[1]}`;
    parts = parts.join("svg ");
  }
  return <div dangerouslySetInnerHTML={{ __html: parts }} />;
};
